export const SET_COLUMN_ORDER = "dataGrid/SET_COLUMN_ORDER";
export const SET_COLUMN_WIDTHS = "dataGrid/SET_COLUMN_WIDTHS";
export const SET_CURRENT_PAGE = "dataGrid/SET_CURRENT_PAGE";
export const SET_FILTERS = "dataGrid/SET_FILTERS";
export const SET_HIDDEN_COLS = "dataGrid/SET_HIDDEN_COLS";
export const SET_PAGE_SIZE = "dataGrid/SET_PAGE_SIZE";
export const SET_SORTING = "dataGrid/SET_SORTING";

export function setColumnOrder(name, columnOrder = []) {
  return {
    type: SET_COLUMN_ORDER,
    name,
    columnOrder
  };
}

export function setColumnWidths(name, columnWidths = []) {
  return {
    type: SET_COLUMN_WIDTHS,
    name,
    columnWidths
  };
}

export function setCurrentPage(name, currentPage, saveState = false) {
  return {
    type: SET_CURRENT_PAGE,
    name,
    currentPage,
    saveState,
  };
}

export function setPageSize(name, pageSize, saveState = false) {
  return {
    type: SET_PAGE_SIZE,
    name,
    pageSize,
    saveState,
  };
}

export function setFilters(name, filters, saveState = false) {
  return {
    type: SET_FILTERS,
    name,
    filters,
    saveState,
  };
}

export function setSorting(name, sorting, saveState = false) {
  return {
    type: SET_SORTING,
    name,
    sorting,
    saveState,
  };
}

export function setHiddenCols(name, hiddenCols) {
  return {
    type: SET_HIDDEN_COLS,
    name,
    hiddenCols,
  }
}